import React, { createContext } from "react";
import { useLocalObservable } from "mobx-react";
import { AgentStore } from "./agentStore";

export const AgentContext = createContext<AgentStore | null>(null);
AgentContext.displayName = "AgentContext";

export const AgentProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const store = useLocalObservable(() => new AgentStore());
  return <AgentContext.Provider value={store}>{children}</AgentContext.Provider>;
};
